<template>
  <tr class="comp-list-item" v-if="computedRow.length > 0" @click="handleSelect">
    <td></td>
    <td v-for="(item, idx) in computedRow" :key="`list-row-cell-${idx}`">
      <component v-if="item.component" :is="item.component" v-bind="{ values: item.values }" />
      <div v-else>{{ item.value }}</div>
    </td>
    <td>
      <template v-if="isNotAssigned">
        <div class="overlay">
          <span>Umteilung benötigt</span>
          <button @click.stop.prevent="handleTransfer">Umteilen</button>
        </div>
      </template>
      <template v-else-if="computedStatus === InquiryStatus.REVIEWING && isOwner">
        <div class="overlay">
          <span>In Überprüfung bei {{ (data.reviewer || {}).name || '???' }}</span>
          <a href="#" @click.stop.prevent="handleReviewDrawback">Zurückrufen</a>
        </div>
      </template>
      <template v-else>
        <div class="context" @click.prevent.stop="$emit('context', $event)">
          <Icon name="menu" />
        </div>
      </template>
    </td>
  </tr>
</template>

<script>
  import ProgressCircle from '@/components/ui/ProgressCircle';
  import StatusLabel from '@/components/inquiry/InquiryStatusLabel';
  import InquiryStatus from '@/objects/InquiryStatus';
  import Icon from '@/components/ui/Icon';
  import { Store } from '@/store';
  import VueUtil from '@/utils/VueUtil';
  import ModalInquiryTransfer from '@/components/modals/ModalInquiryTransfer';

  export default {
    name: 'ListItem',
    components: {
      Icon,
      StatusLabel,
      ProgressCircle,
    },
    //---------------------------------------------------
    //
    //  Properties
    //
    //---------------------------------------------------
    props: {
      data: {
        type: Object,
        default: () => {},
      },
      actions: {
        type: Array,
        default: () => [],
      },
      structure: {
        type: Object,
        default: () => {},
      },
    },
    //---------------------------------------------------
    //
    //  Data model
    //
    //---------------------------------------------------
    data() {
      return {
        InquiryStatus,
      };
    },
    //---------------------------------------------------
    //
    //  Computed Properties
    //
    //---------------------------------------------------
    computed: {
      computedRow() {
        const out = [];
        const data = this.data;
        const structure = this.structure;
        const keys = Object.keys(structure);
        keys.forEach((key) => {
          const value = data[key];
          const struct = structure[key];
          const obj = { id: key, value };
          if (struct?.component) {
            obj.component = struct.component;
            obj.values = data;
          } else if (struct?.format) {
            obj.value = struct.format(value, data);
          }
          out.push(obj);
        });
        return out;
      },
      computedStatus() {
        return this.data.status || null;
      },
      isOwner() {
        return Store.uuid === this.data?.psychologist.uuid;
      },
      isNotAssigned() {
        return this.data?.psychologist === null;
      },
    },
    //---------------------------------------------------
    //
    //  Watch Properties
    //
    //---------------------------------------------------
    watch: {},
    //---------------------------------------------------
    //
    //  Filter Properties
    //
    //---------------------------------------------------
    // filters: {},
    //---------------------------------------------------
    //
    //  Validation Properties
    //
    //---------------------------------------------------
    // validations: {},
    //---------------------------------------------------
    //
    //  Vue Lifecycle
    //
    //---------------------------------------------------
    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // render(h) { return h(); },
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // beforeDestroy() {},
    // destroyed() {},
    //---------------------------------------------------
    //
    //  Methods
    //
    //---------------------------------------------------
    methods: {
      //----------------------------------
      // Event Handlers
      //----------------------------------
      handleSelect() {
        if (this.computedStatus !== InquiryStatus.REVIEWING || !this.isOwner) {
          this.$emit('select');
        }
      },
      async handleReviewDrawback() {
        console.log(this.data);
        const uuid = this.data?.uuid;
        if (uuid) {
          const response = await this.$sav.api.delete('/inquiry/review', null, {
            uuid,
            status: InquiryStatus.PROGRESS_COMPLETE,
          });
          if (response) {
            this.$emit('reload');
          }
        }
      },
      handleTransfer() {
        const inquiryid = this.data?.inquiryid;
        const isAssigned = this.data?.psychologist !== null && this.data?.psychologist !== undefined;
        const modal = VueUtil.createComponent(ModalInquiryTransfer, document.body, {
          propsData: {
            inquiryid,
            isAssigned,
          },
          parent: this,
        });
        modal.$once('done', async () => { this.$emit('reload'); });
      },
    },
  };
</script>

<style lang="scss">
@import '~scss/mixins';
@import '~scss/variables';

.comp-list-item {
  z-index: 1;
  background-color: transparent;
  will-change: background-color;
  transition: background-color 0.2s linear;

  & > td {
    height: 60px;
    @include font-body-medium;
    color: black;
    border-bottom: 1px solid $color-black-alpha-10;
    will-change: border-bottom;
    transition: border-bottom 0.2s linear;

    &:first-of-type {
      max-width: 20px;
      min-width: 20px;
      width: 20px;
    }

    &:last-of-type {
      position: relative;
      & > div.context {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 32px;
        height: 32px;
        background-color: $color-black-alpha-05;
        border-radius: $default-border-radius;
        cursor: pointer;

        & > svg {
          width: 14px;
          height: 14px;
          color: $color-black-solid-100;
        }
      }
      & > div.overlay {
        position: absolute;
        right: 0;
        top: 0;
        width: calc(100vw - (80px + var(--sbw)));
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        background: $color-white-alpha-80;
        padding: 0 20px;

        span {
          display: inline-block;
          margin-right: 11px;
          @include font-body-medium-semibold;
          background: $color-white-alpha-80;
          padding: 4px 4px;
        }

        button {
          @include font-button;
          text-transform: uppercase;
          border: 0;
          outline: 0;
          padding: 8px 16px;
          border-radius: 4px;
          background-color: $color-blue-solid-100;
          color: $color-white-solid-10;
        }

        a {
          @include font-body-small;
          color: $color-black-alpha-60;
        }
      }
    }
  }

  &:hover {
    background-color: $color-blue-alpha-10;
    & > td {
      border-bottom: 1px solid $color-blue-solid-100;
    }
  }
}
</style>
